<template>
    <div>
        <div v-if="getEnviroViewNo == 0">
            <div class="sizer-col">
                <div class="size-window size-left">
                    <div class="size-window size-top">
                        <Assignment v-bind:assignment="dcontent.data.content" />
                    </div>
                    <div class="sizer" data-sizer="y" @mouseup="saveEnviroViewDimensions"></div>
                    <div class="size-window size-bottom">
                        <div>
                            <VueTerm v-bind:dcontent="dcontent" v-bind:taskIndex="taskIndex" v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
                        </div>
                    </div>
                </div>
                <div class="sizer" data-sizer="x" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-right">
                    <div class="pa-0 d-flex fill-height">
                        <CodeEditor v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type"/>
                    </div>
                </div>  
            </div>
        </div>
        
        <div v-if="getEnviroViewNo == 1">
            <div class="sizer-col">
                <div class="size-window size-left">
                    <div class="pa-0 d-flex fill-height">
                        <CodeEditor v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type"/>
                    </div>
                </div>
                <div class="sizer" data-sizer="x" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-right">
                    <div class="size-window size-top">
                        <Assignment v-bind:assignment="dcontent.data.content" />
                    </div>
                    <div class="sizer" data-sizer="y" @mouseup="saveEnviroViewDimensions"></div>
                    <div class="size-window size-bottom">
                        <div>
                            <VueTerm v-bind:dcontent="dcontent" v-bind:taskIndex="taskIndex" v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="getEnviroViewNo == 2">
            <div class="sizer-row">
                <div class="size-window size-top">
                    <Assignment v-bind:assignment="dcontent.data.content" />
                </div>
                <div class="sizer" data-sizer="y" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-bottom">
                    <div class="size-window size-left pa-0">
                        <div class="pa-0 d-flex fill-height">
                            <CodeEditor v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type"/>
                        </div>
                    </div>
                    <div class="sizer" data-sizer="x" @mouseup="saveEnviroViewDimensions"></div>
                    <div class="size-window size-right">
                        <div>
                            <VueTerm v-bind:dcontent="dcontent" v-bind:taskIndex="taskIndex" v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="getEnviroViewNo == 3">
            <div class="sizer-row">
                <div class="size-window size-top">
                    <div class="size-window size-left">
                        <Assignment v-bind:assignment="dcontent.data.content" />
                    </div>
                    <div class="sizer" data-sizer="x" @mouseup="saveEnviroViewDimensions"></div>
                    <div class="size-window size-right">
                        <div>
                            <VueTerm v-bind:dcontent="dcontent" v-bind:taskIndex="taskIndex" v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
                        </div>
                    </div>
                </div>
                <div class="sizer" data-sizer="y" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-bottom">
                    <div class="pa-0 d-flex fill-height">
                        <CodeEditor v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type"/>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="getEnviroViewNo == 4">
            <div class="sizer-row">
                <div class="size-window size-top">
                    <div>
                       <Assignment v-bind:assignment="dcontent.data.content" />
                    </div>
                </div>
                <div class="sizer" data-sizer="y" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-middle-y">
                    <div class="pa-0 d-flex fill-height">
                       <CodeEditor v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type"/>
                    </div>
                </div>
                <div class="sizer" data-sizer="y" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-bottom">
                    <div>
                       <VueTerm v-bind:dcontent="dcontent" v-bind:taskIndex="taskIndex" v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
                    </div>
                </div>
            </div>
        </div>



        <div v-if="getEnviroViewNo == 5">
            <div class="sizer-col">
                <div class="size-window size-left">
                    <div>
                        <Assignment v-bind:assignment="dcontent.data.content" />                        
                    </div>
                </div>
                <div class="sizer" data-sizer="x" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-middle-x">
                    <div class="pa-0 d-flex fill-height">
                        <CodeEditor v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type"/>
                    </div>
                </div>
                <div class="sizer" data-sizer="x" @mouseup="saveEnviroViewDimensions"></div>
                <div class="size-window size-right">
                    <div>
                        <VueTerm v-bind:dcontent="dcontent" v-bind:taskIndex="taskIndex" v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import VueTerm from '../../elements/vue_term/vueterm.vue'
import Assignment from '../assignment/assignment.vue'
import CodeEditor from '../lab/codeeditor.vue'

 
export default {
    data() {
        return {
            layoutStorageValues: new Map(),
        }
    },    
    computed: 
        mapGetters([
            'getEnviroViewNo',
            'getEnviroViewDimensions'              
        ]),
    props : {
            showAssignment : Boolean,
            dcontent: Object,
            taskIndex: Number,
            activity_type: String,
            startTime: Date
        },
    components: {
        CodeEditor,
        VueTerm,
        Assignment
    },
    watch: {
        getEnviroViewNo: function(){
            // po odsledovani zmeny hodnoty je este potrebne pockat, 
            // kym Vue cez v-if vykresli dynamicky elementy a az potom spsutit metodu na odchytenie novopridanych elementov na prisposobovanie sirky_vysky okien
            setTimeout(() => this.resize(), 100); 

            // **********************
            // na prepnutie zobrazenia
            // **********************
                // 1) precistit lokalnu mapu hodnot preferencii
                this.layoutStorageValues.clear();

                // 2) zavolat metodu pridelovania adekvatneho vzhladu na zaklade ulozenej preferencie
                // this.applyEnviroViewDimensions(); // bez Timeout-u chyba: "TypeError: Cannot read properties of undefined (reading 'style')"

                // cakame kym Vue cez v-if vykresli elementy...
                setTimeout(() => this.applyEnviroViewDimensions(), 100); 
        }
    },
    mounted() {
        this.resize();
    },
    methods: {
        resize() {
                const ref = this;        

                // resetovanie style atributu po switch-nuti zobrazenia
                this.$el.querySelectorAll('.size-window').forEach(function(item) {
                    if (item.hasAttribute("style")) {
                        // potrebne pouzivat removeAttribute nie setAttribute (sposobuje chyby - sirka)
                        item.removeAttribute("style");
                    }

                    if (item.firstChild.hasAttribute("style")) {
                        // potreba taktiez osetrit aj prvy div (firstChild) v .size-window
                        item.firstChild.removeAttribute("style");
                    }
                });

                this.applyEnviroViewDimensions();
                
                var size = function (sizer) {
                    var direction = sizer.dataset.sizer || "x";
                    var prev = sizer.previousElementSibling;
                    var next = sizer.nextElementSibling;
                    var prevHeight = 0;
                    var prevWidth = 0;  
                    var x = 0;
                    var y = 0;

                var sizeUp = function () {
                [
                    [sizer.style, "cursor"],
                    [document.body.style, "cursor"],
                    [prev.style, "user-select"],
                    [prev.style, "pointer-events"],
                    [next.style, "user-select"],
                    [next.style, "pointer-events"],
                ].forEach(function (item) {
                    item[0].removeProperty(item[1]);
                });
                document.removeEventListener("mousemove", sizeMove);
                document.removeEventListener("mouseup", sizeUp);
                };

                var sizeDown = function (event) {
                var rect = prev.getBoundingClientRect();
                prevHeight = rect.height;
                prevWidth = rect.width;
                x = event.clientX;
                y = event.clientY;

                document.addEventListener("mousemove", sizeMove);
                document.addEventListener("mouseup", sizeUp);
                };

                var sizeMove = function (event) {
                var dx = event.clientX - x;
                var dy = event.clientY - y; 
                var cursor = direction === "x" ? "col-resize" : "row-resize";
                document.body.style.cursor = cursor;
                sizer.style.cursor = cursor;

                var classElement = prev.classList.value.replace('size-window', '');
                // osetrit vymaz medzier, nepotrebne classy (enviroN = 2)
                var editedClassElement = classElement.slice(classElement.startsWith("size-")).trim().split(' ')[0];

                if (direction === "y" && prev.classList.contains('size-top') || prev.classList.contains('size-bottom') || prev.classList.contains('size-middle-y')) { // height: menime len pre .size-top a .size-bottom
                    let valueH = ((prevHeight + dy) * 100) / sizer.parentElement.getBoundingClientRect().height;
                    prev.style.height = valueH + "%";

                    ref.layoutStorageValues.set(editedClassElement+'---'+ref.getEnviroViewNo, {height: valueH});
                } else if(direction === "x" && prev.classList.contains('size-right') || prev.classList.contains('size-left') || prev.classList.contains('size-middle-x')) { // width: menime len pre .size-right a .size-left
                    let valueW = ((prevWidth + dx) * 100) / sizer.parentElement.getBoundingClientRect().width;
                    prev.style.width = valueW + "%";

                    ref.layoutStorageValues.set(editedClassElement+'---'+ref.getEnviroViewNo, {width: valueW});
                }

                Object.assign(prev.style, {
                    userSelect: "none",
                    pointerEvents: "none",
                });
                Object.assign(next.style, {
                    userSelect: "none",
                    pointerEvents: "none",
                });
                };


                sizer.addEventListener("mousedown", sizeDown);
            };

            [].slice
                .call(this.$el.querySelectorAll('.sizer'))
                .forEach(function (item) {
                size(item);
                });
        },
        applyEnviroViewDimensions() {
            const ref = this;        

            // inicialiacia spatnej rekonstrukcie aplikovania vzhladu – hodnot velkosti okien
            // pokial avsak mame na dane zobrazenie nejaku preferenciu
            //console.log(this.getEnviroViewDimensions);

            // for loop – prehladame zaznamy pre aktualny EnviroViewNo
            for (const [key, value] of this.getEnviroViewDimensions.entries()) {
                var tempKeyArray = key.split("---");
                //console.log(tempKeyArray[0]); // get class
                //console.log(tempKeyArray[1]); // get environment view number
                var tempClassName = tempKeyArray[0], tempEnvironmentViewNumber = tempKeyArray[1];

                if (value) {
                    //console.log(value); // get value for specific class & environment view number
                    //console.log(Object.keys(value)[0]); 
                    //console.log(Object.values(value)[0]); 
                    var tempCSSProperty = Object.keys(value)[0], tempCSSPropertyValue = Object.values(value)[0];
                

                    // ak existuje zaznam aplikujeme css vlastnosti width / height
                    // najdeme element s classom a pridame CSS hodnotu
                    // nepotrebujeme osetrovat jedinecne identifikatory elementov s rovnakym classom lebo v jeden moment je cez v-if dostupne len jedno zobrazenie
                    if (tempEnvironmentViewNumber == ref.getEnviroViewNo) {

                        // odchytime konkretny element a pridame css ulozeneho vzhladu
                        switch (tempCSSProperty) {
                            case "width":
                                // document.getElementsByClassName(tempClassName)[0].style.width = tempCSSPropertyValue+"%";
                                document.getElementsByClassName(tempClassName)[0].style.setProperty('width', (tempCSSPropertyValue+"%"));
                                break;

                            case "height":
                                // document.getElementsByClassName(tempClassName)[0].style.height = tempCSSPropertyValue+"%";
                                document.getElementsByClassName(tempClassName)[0].style.setProperty('height', (tempCSSPropertyValue+"%"));
                                break;
                        
                            default:
                                break;
                        }
                        
                    }
                }
            }
        },
        saveEnviroViewDimensions() {
            this.$store.commit('setEnviroViewDimensions', this.layoutStorageValues);
        }
    }
}

</script>